export const NEWS_VIEW_GRAPH = 'NEWS_VIEW_GRAPH';
export const NEWS_TOTAL = 'NEWS_TOTAL';
export const NEWS_PER_CATEGORY = 'NEWS_PER_CATEGORY';
export const NEWS_PER_SUBCATEGORY = 'NEWS_PER_SUBCATEGORY';
export const NEWS_SUBCATEGORIES = 'NEWS_SUBCATEGORIES';
export const NEWS_COD_CATEGORY = 'NEWS_COD_CATEGORY';
export const NEWS_COD_SUBCATEGORY = 'NEWS_COD_SUBCATEGORY';
export const NEWS_LOADING = 'NEWS_LOADING';